<form [formGroup]="panFormGroup" (ngSubmit)="onSubmit(panFormGroup)">
    <p class="heading">Lets validate your PAN</p>

    <p class="form-field-heading">Name as on PAN card</p>
    <div class="row">
        <mat-form-field class="col-xs-12">
            <input type="text" matInput placeholder="Enter exact name as on PAN" formControlName="name" maxlength="50">
            <mat-error>{{ getErrorMessage(panFormGroup.controls.name) }}</mat-error>
        </mat-form-field>
    </div>

    <div class="grey-section px-5 py-3 mb-3 mt-2" *ngIf="isPanNameNotMatched(panFormGroup.controls.name)">
        <p>A name mismatch issue may be resolved by entering your name in its full form.</p>
        <p>For example:<br>
            <span class="glyphicon glyphicon-remove-circle pr-1"></span>If your PAN has <b>Rahul K S</b>.<br>
            <span class="glyphicon glyphicon-ok-circle pr-1"></span> Please enter the full form - <b>Rahul Kumar
                Singh</b> and
            try again
        </p>
        <p class="m-0">If you continue facing an issue verifying your PAN, please write to us at
            <span class="text-color-finzy-blue">support@finzy.com</span></p>
    </div>

    <p class="form-field-heading">PAN number</p>
    <div class="row">
        <mat-form-field class="col-xs-12">
            <input style="text-transform: uppercase" type="text" maxlength="10" matInput placeholder="Eg : ASDFG4567H"
                   formControlName="pan">
            <mat-error>{{ getErrorMessage(panFormGroup.controls.pan) }}</mat-error>
        </mat-form-field>
    </div>

    <div class="row">
        <div class="col-xs-6">
            <button mat-stroked-button class="button-back primary" type="button" (click)="previousPage()">
                <i class="material-icons">arrow_back</i>&nbsp;&nbsp;&nbsp;BACK
            </button>
        </div>
        <div class="col-xs-6">
            <div class="pull-right">
              <app-forward-button class="button-forward" [isLoading]="shouldShowLoader"
                                  (click)="analyticsTracker.trackButtonClick('Pan Verification', 'Next')">
                NEXT
              </app-forward-button>
            </div>
        </div>
    </div>
</form>
